const WebinarForm = {
	init: function (wrapper) {
		const form = wrapper.querySelector('form');
		if (!form) {
			return;
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const submitButton = form.querySelector('[type="submit"]');
			if (submitButton) {
				submitButton.disabled = true;
			}

			fetch(form.action, {
				method: 'POST',
				body: new FormData(form),
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Accept': 'application/json',
				},
			})
				.then(response => response.json())
				.then(data => {
					wrapper.querySelectorAll('.webinar-form-message').forEach(el => el.remove());

					const message = document.createElement('div');
					message.className = 'webinar-form-message alert ' + (data.success ? 'alert-success' : 'alert-danger');
					message.textContent = data.message;

					if (data.success) {
						form.replaceWith(message);
					} else {
						wrapper.appendChild(message);
						if (submitButton) {
							submitButton.disabled = false;
						}
					}
				})
				.catch(() => {
					if (submitButton) {
						submitButton.disabled = false;
					}
				});
		});
	}
};

export default WebinarForm;
